import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { actions } from "../model";
import { getEventTimezone } from "redux/modules/event/selectors";
import { Div } from "components/Base";
import moment from "moment-timezone";

import CSSModules from "react-css-modules";
import css from "./styles.scss";
import DeleteConfirmation from "components/Global/CRM/Popovers/DeleteConfirmation";

import MenuPopover from "Portal/NewPortal/HeaderBar/View/MenuPopover";
import MenuItem from "material-ui/MenuItem";
import { SUBSESSION_ACTIONS } from "../constants";

import CanUserDo from "components/Global/Security/CanUserDo";
import * as STANDARD_MODULE_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-modules";

const decorate = R.compose(
  connect(
    state => ({
      timezone: getEventTimezone(state)
    }),
    {
      goToSubsession: actions.goToSubsession,
      onMenuSelectSubsession: actions.onMenuSelectSubsession
    }
  ),
  CSSModules(css)
);

export const Subsession = ({
  subsession,
  timezone,
  onMenuSelectSubsession,
  goToSubsession,
  handlers
}) => {
  const {
    title = "",
    id = "",
    format = {},
    friendly_id = "",
    related_content = []
  } = subsession || {};

  const numberOfContents = R.length(related_content);

  return (
    <Div
      key={id}
      bra={1}
      ba={1}
      bc="gray3"
      p={5}
      mb={3}
      bg={{
        default: "white",
        hover: "gray1"
      }}
    >
      <Div mb={1} display="row.flex-start.center">
        <Div flex={1} mr={2} fw={4} fs={4} color="black">
          {title}
        </Div>

        <MenuPopover
          Label={
            <i className={[css.icon, "material-icons"].join(" ")}>more_horiz</i>
          }
        >
          {({ closePopover }) => (
            <Div bra={3} bg="white" width={1} py={2}>
              <MenuItem
                onClick={e => {
                  e.stopPropagation();
                  goToSubsession(id);
                  closePopover();
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className={["material-icons"].join(" ")}>edit</i>
                  <div style={{ marginLeft: "2px" }}>Edit</div>
                </div>
              </MenuItem>

              <CanUserDo action={`${STANDARD_MODULE_IDS.sessions.id}_update`}>
                <DeleteConfirmation
                  onConfirm={e => {
                    e.stopPropagation();
                    onMenuSelectSubsession({
                      subsessionId: id,
                      method: SUBSESSION_ACTIONS.unlink,
                      handlers
                    });
                    closePopover();
                  }}
                  text="Are you sure you want to convert"
                  secondayText="this subsession to a session?"
                  popoverStyle={{ zIndex: 3999 }}
                  cancelLabel="No"
                  confirmLabel="Yes"
                >
                  <MenuItem>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <i className={["material-icons"].join(" ")}>link_off</i>

                      <div style={{ marginLeft: "2px" }}>Unlink</div>
                    </div>
                  </MenuItem>
                </DeleteConfirmation>
              </CanUserDo>

              <CanUserDo action={`${STANDARD_MODULE_IDS.sessions.id}_delete`}>
                <DeleteConfirmation
                  onConfirm={e => {
                    e.stopPropagation();
                    onMenuSelectSubsession({
                      subsessionId: id,
                      method: SUBSESSION_ACTIONS.delete,
                      handlers
                    });
                    closePopover();
                  }}
                  text="Are you sure you want to"
                  secondayText="permanently delete this subsession?"
                  popoverStyle={{ zIndex: 3999 }}
                  cancelLabel="No"
                  confirmLabel="Yes"
                >
                  <MenuItem>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <i className={["material-icons"].join(" ")}>delete</i>
                      <div style={{ marginLeft: "2px" }}>Delete</div>
                    </div>
                  </MenuItem>
                </DeleteConfirmation>
              </CanUserDo>
            </Div>
          )}
        </MenuPopover>
      </Div>
      <Div display="row.flex-start.center" width={1}>
        <Div
          display="column"
          style={{
            width: "20%"
          }}
        >
          <Div fs={1}>Session ID</Div>
          <Div fs={1} color="gray7">
            {friendly_id}
          </Div>
        </Div>
        <Div
          display="column"
          style={{
            width: "20%"
          }}
        >
          <Div fs={1}>Starts At</Div>
          <Div fs={1} color="gray7">
            {R.prop("starts_at")(subsession)
              ? moment
                  .tz(R.prop("starts_at")(subsession), timezone)
                  .format("MMM D, YYYY @ h:mm A")
              : "-"}
          </Div>
        </Div>
        <Div
          display="column"
          style={{
            width: "20%"
          }}
        >
          <Div fs={1}>Ends At</Div>
          <Div fs={1} color="gray7">
            {R.prop("ends_at")(subsession)
              ? moment
                  .tz(R.prop("ends_at")(subsession), timezone)
                  .format("MMM D, YYYY @ h:mm A")
              : "-"}
          </Div>
        </Div>
        <Div
          display="column"
          style={{
            width: "20%"
          }}
        >
          <Div fs={1}>Format</Div>
          <Div fs={1} color="gray7">
            {R.propOr("-", "name")(format)}
          </Div>
        </Div>
        <Div
          display="column"
          style={{
            width: "20%"
          }}
        >
          <Div fs={1}>Files</Div>
          <Div fs={1} color="gray7">
            {numberOfContents > 0 ? (
              <>
                {numberOfContents} file{numberOfContents > 1 ? "s" : ""}{" "}
                uploaded
              </>
            ) : (
              "-"
            )}
          </Div>
        </Div>
      </Div>
    </Div>
  );
};

export default decorate(Subsession);
